import { motion } from "framer-motion";
import { _TEST1234 } from "../../config/ApiConfig";

export const LoginHeaderImage = () => {
    return (
        <div className="absolute w-full h-full top-0 left-0 flex flex-col justify-start items-center pt-12 sm:hidden">
            <img
                src={process.env.PUBLIC_URL + "/imgs/egaLogo.png"}
                alt="login image buildings"
                title="login image buildings"
                width={200}
                height={200}
            />
            <p className="mt-3 text-3xl font-bold tracking-widest" style={{ color: "#065F46" }}>ONE STOP CENTER PORTAL</p>
        </div>
    );
};
